import { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import './SideBarWithMenu.scss';

import CSLogo from '../../icons/CSLogo.png';
import Limn_labs_logo from '../../icons/LL_LOGO.svg';
import { menuItems } from './constants.js';
import dateFormat from 'dateformat';
import UserService from '../../services/UserService';

import support from '../../icons/submenu/support.png';
import logout from '../../icons/submenu/logout.png';
import settings from '../../icons/settings.png';
import chat from '../../icons/submenu/chat.png';
import contact from '../../icons/submenu/contact.png';
import product from '../../icons/submenu/product.png';

import QuestionIcon from '../../assets/QuestionIcon.svg';
import NetworkStatus from '../networkStatus/networkStatus';
import Breadcrumb from './Breadcrumb';
import axios from 'axios';
import { getLoggedInUserInfo } from './utils';
import {
    setCompanyDetails,
    setCompanyList,
    setIsLLAdminUser,
    setLoggedInUserId,
    setLoggedinUsername,
} from './sidebarreducer';

import { useDispatch, useSelector } from 'react-redux';
import { css } from '@emotion/react';
import { setEnableTouchKeyboard } from '../scan/scanReducer';
import virtualKeyboard from '../../icons/virtual-keyboard.png';
import { RootState } from '../../redux/store';
import { setLocalStorageItems } from '../scan/utils';

const now = new Date();

const SidebarWithMenu = ({ children }) => {
    const sideBarRef = useRef(null);
    const history = useHistory();
    const [currentMapper, setCurrentMapper] = useState('/home');

    const [showMenu, setShowMenu] = useState(false);

    const [showHelpMenu, setShowHelpMenu] = useState(false);
    const [showPageContent, setShowPageContent] = useState(false);

    const [username, setUserName] = useState('');
    let [structedMenuItems, setStructeredMenuItems] = useState([]);
    let [loggedinUserInfo, setLoggedInUserInfo] = useState([]);

    const [touchMode, setTouchMode] = useState(true);
    const [reclaimCenterName, setReclaimCenterName] = useState('');

    const companyDetails = useSelector(
        (state: RootState) => state.sideBarReducer.companyDetails
    );

    // const isLLAdminUser = useSelector(
    //     (state: RootState) => state.sideBarReducer.isLLAdminUser
    // );

    // const companyList = useSelector(
    //     (state: RootState) => state.sideBarReducer.companyList
    // );

    // const handleCompanyChange = (arg) => {
    //     try {
    //         const userCompanyMapping = companyList.find(
    //             (ele) => ele.companyId === parseInt(arg.target.value)
    //         );
    //         //console.log(userCompanyMapping);
    //         setLocalStorageItems('companyId', arg.target.value);
    //         dispatch(setCompanyDetails(userCompanyMapping));
    //     } catch (error) {
    //         //console.log(error);
    //     }
    // };

    // const signOutButton = <button onClick></button>

    useEffect(() => {
        // perform side effect
        usergetLoggedInUser(UserService.getUsername());
    }, [UserService.getUsername()]);

    const handleLogout = () => {
        // history.push('/home');
        UserService.doLogout();
    };
    const dispatch = useDispatch();

    useEffect(() => {
        if (sideBarRef.current) {
            if (sideBarRef.current.isOpen) {
                sideBarRef.current.toggle();
            }
        }
    }, [1]);

    useEffect(() => {
        if (Object.keys(companyDetails).length > 0) {
            getMenuDetails(companyDetails);
        }
    }, [companyDetails]);

    const usergetLoggedInUser = async (token) => {
        try {
            setUserName(token.preferred_username);
            const endPointURL = getLoggedInUserInfo();
            await axios
                .post(endPointURL)
                .then((res) => {
                    if (res.status === 200) {
                        setShowPageContent(true);
                        res.data['userCompanyMapping'] =
                            res.data['userCompanyMapping'] || [];
                        let dataa = res.data;
                        let userCompanyData = [];
                        let mappedRoles = [];

                        dataa['userCompanyMapping'].forEach((element) => {
                            userCompanyData.push({
                                ...element,
                                companyName: element?.company?.companyName,
                                companyId: element?.companyId,
                                id: element?.companyId,
                            });
                        });
                        dispatch(setCompanyList(userCompanyData));

                        // //console.log(userCompanyData)

                        // userCompanyData.forEach((element) => {
                        //     mappedRoles =
                        //         element['roles'].map(({roleName}) => {
                        //             return roleName;
                        //         });
                        // });

                        // //console.log(mappedRoles);

                        setLoggedInUserInfo(dataa);
                        dispatch(setLoggedinUsername(dataa.username));
                        dispatch(setLoggedInUserId(dataa.id));

                        if (userCompanyData?.length > 0) {
                            const userCompanyMapping = userCompanyData[0];
                            setLocalStorageItems(
                                'companyId',
                                userCompanyMapping?.companyId
                            );
                            dispatch(setCompanyDetails(userCompanyMapping));
                            // getMenuDetails(userCompanyMapping);
                        }
                    }
                })
                .catch((err) => {
                    setShowPageContent(true);
                    //console.log(err);
                });
        } catch (error) {}
    };

    const getMenuDetails = (userCompanyMapping) => {
        try {
            const menuJson = [];
            // dispatch(setCompanyDetails(userCompanyMapping));
            setReclaimCenterName(
                userCompanyMapping?.reclaimCenter?.reclaimcenterName
            );
            let mappedRoles = [];
            userCompanyMapping['roles'].forEach((element) => {
                mappedRoles = [...mappedRoles, ...element['roleModuleMapping']];
            });

            const ids = mappedRoles.map(({ moduleId }) => moduleId);
            const roleNames = mappedRoles.map(({ roleId }) => roleId);
            //console.log(roleNames.indexOf(99) > -1);
            dispatch(
                setIsLLAdminUser(roleNames.indexOf(99) > -1 ? true : false)
            );

            const filterMappedRoles = mappedRoles.filter(
                ({ moduleId }, index) => !ids.includes(moduleId, index + 1)
            );

            menuItems?.map((parent) => {
                filterMappedRoles?.map((children) => {
                    if (
                        parent.text.toLowerCase() ===
                        children.roleModule.moduleName.toLowerCase()
                    ) {
                        Object.assign(parent, {
                            roleModuleMenu: children.roleModule.roleModuleMenu,
                        });
                        menuJson.push(parent);
                    }
                });
            });
            setStructeredMenuItems(
                menuJson.filter(
                    (ele, ind) =>
                        ind ===
                        menuJson.findIndex((elem) => elem.text === ele.text)
                )
            );
        } catch (error) {}
    };

    const handleTouch = (value) => {
        const checked = Boolean(value.target.checked);
        setTouchMode(checked);
        dispatch(setEnableTouchKeyboard(checked));
    };

    const handleItemSelectNew = (mapper, item) => {
        setCurrentMapper(mapper);
        history.push(mapper);
        history.push(item);
        //console.log(showHelpMenu);
        //console.log(showMenu);
        setShowHelpMenu(false);
        setShowMenu(false);
    };

    const handleHelpMenu = () => {
        setShowHelpMenu(!showHelpMenu);
        setShowMenu(false);
    };
    const handleProfileMenu = () => {
        setShowHelpMenu(false);
        setShowMenu(!showMenu);
    };

    return (
        <div>
            {showPageContent ? (
                <div className="control-section sidebar-menu">
                    <>
                        <NetworkStatus />
                        <div id="wrapper">
                            <div className="col-lg-12 col-sm-12 col-md-12">
                                <div className="col-lg-1 col-sm-1 col-md-1 sideBar">
                                    <div className="menu-item-logo">
                                        <img src={CSLogo} alt="CSLogo" />
                                    </div>

                                    {structedMenuItems &&
                                    structedMenuItems.length > 0 &&
                                    structedMenuItems !== undefined ? (
                                        <div>
                                            {structedMenuItems &&
                                                structedMenuItems?.map(
                                                    (item) => {
                                                        return (
                                                            <div
                                                                className={`menu-item ${
                                                                    currentMapper ===
                                                                        item.mapper &&
                                                                    currentMapper !==
                                                                        '/LLAdmin'
                                                                        ? ' menu-item-active'
                                                                        : currentMapper ===
                                                                              item.mapper &&
                                                                          currentMapper ===
                                                                              '/LLAdmin'
                                                                        ? 'lladmin-active'
                                                                        : ''
                                                                } `}
                                                                onClick={() =>
                                                                    handleItemSelectNew(
                                                                        item.mapper,
                                                                        item
                                                                    )
                                                                }
                                                            >
                                                                <li
                                                                    className={
                                                                        item.mapper ===
                                                                        '/settings'
                                                                            ? 'touch-border'
                                                                            : ''
                                                                    }
                                                                >
                                                                    <li
                                                                        className={
                                                                            currentMapper ===
                                                                                item.mapper &&
                                                                            currentMapper ===
                                                                                '/touch'
                                                                                ? 'cs-touch-icon-active sidemenu-icons'
                                                                                : item.iconCss
                                                                        }
                                                                    >
                                                                        <img
                                                                            src={
                                                                                item.imgPath
                                                                            }
                                                                            alt="logo"
                                                                            className="img img-fluid"
                                                                        />
                                                                    </li>

                                                                    <p
                                                                        className={`menu-name${
                                                                            currentMapper ===
                                                                                item.mapper &&
                                                                            currentMapper !==
                                                                                '/LLAdmin'
                                                                                ? ' menu-name-active'
                                                                                : currentMapper ===
                                                                                      item.mapper &&
                                                                                  currentMapper ===
                                                                                      '/LLAdmin'
                                                                                ? ' lladmin-name-active'
                                                                                : ''
                                                                        } `}
                                                                    >
                                                                        {
                                                                            item.text
                                                                        }
                                                                    </p>
                                                                </li>
                                                            </div>
                                                        );
                                                    }
                                                )}
                                        </div>
                                    ) : (
                                        <></>
                                    )}
                                    <div className="touch-mode">
                                        <input
                                            type="checkbox"
                                            defaultChecked={touchMode}
                                            id="touchMode"
                                            className="toggle"
                                            onChange={handleTouch}
                                        />

                                        <label htmlFor="touchMode" />
                                        <img
                                            alt="Touch Mode"
                                            src={virtualKeyboard}
                                        />
                                    </div>

                                    <div className="Limn_labs_logo">
                                        <img
                                            src={Limn_labs_logo}
                                            alt="logo"
                                            className="img img-responsive"
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-11 col-sm-11 col-md-11 mainBar">
                                    <div
                                        className="col-lg-12 col-sm-12 col-md-12 p-0 header-section dock-menu"
                                        id="header"
                                    >
                                        <ul className="header-list">
                                            <li
                                                id="hamburger"
                                                className="icon list"
                                            ></li>

                                            <li className="list">
                                                <div className="left-header">
                                                    <p className="location-name">
                                                        {
                                                            companyDetails?.companyName
                                                        }{' '}
                                                        - {reclaimCenterName}
                                                    </p>
                                                </div>
                                            </li>

                                            {/* {!isLLAdminUser && (
                                                <li className="list" >
                                                    <div
                                                        className="d-flex align-items-center"
                                                        style={{
                                                            margin: '0 auto',
                                                            height: '62px',
                                                            marginLeft:"80px"
                                                        }}
                                                    >
                                                        <label
                                                            className="label-title"
                                                            style={{
                                                                color: 'white',
                                                                fontWeight:
                                                                    '400',
                                                                paddingRight: '10px',
                                                            }}
                                                        >
                                                            Company Name{' '}
                                                        </label>
                                                        <select
                                                            style={{
                                                                width: 250,
                                                            }}
                                                            disabled={
                                                                companyList.length ===
                                                                1
                                                            }
                                                            onChange={(e) =>
                                                                handleCompanyChange(
                                                                    e
                                                                )
                                                            }
                                                            value={
                                                                companyDetails?.companyId
                                                            }
                                                            className="form-control"
                                                        >
                                                            {companyList?.map(
                                                                (item, idx) => (
                                                                    <option
                                                                        key={
                                                                            idx
                                                                        }
                                                                        value={
                                                                            item?.companyId
                                                                        }
                                                                    >
                                                                        {
                                                                            item?.companyName
                                                                        }
                                                                    </option>
                                                                )
                                                            )}
                                                        </select>
                                                    </div>
                                                </li>
                                            )} */}

                                            <li className="menubar-options">
                                                <span className="current-day-time-text">
                                                    {dateFormat(
                                                        now,
                                                        'dddd, mmmm dS, yyyy'
                                                    )}
                                                </span>
                                            </li>
                                            <li className="right-header list">
                                                <div className="horizontal-menu">
                                                    <div
                                                        className="e-avatar e-avatar-small e-avatar-circle profile-image"
                                                        onClick={() =>
                                                            handleHelpMenu()
                                                        }
                                                    >
                                                        <img
                                                            src={QuestionIcon}
                                                            className="img-fluid"
                                                            alt="logo"
                                                        />
                                                    </div>
                                                    {showHelpMenu ? (
                                                        <ul
                                                            className="submenu-show help-menu"
                                                            style={{
                                                                background:
                                                                    'white !important',
                                                            }}
                                                        >
                                                            <li className="submenu-list list-border">
                                                                <span className="submenu-option ">
                                                                    <img
                                                                        src={
                                                                            support
                                                                        }
                                                                        alt="logo"
                                                                        className="img-fluid submenu-option-icon"
                                                                    />
                                                                    Help &
                                                                    Support
                                                                </span>
                                                            </li>

                                                            <li className="submenu-list list-border">
                                                                <span className="submenu-option ">
                                                                    <img
                                                                        src={
                                                                            chat
                                                                        }
                                                                        alt="logo"
                                                                        className="img-fluid submenu-option-icon"
                                                                    />
                                                                    Chat with us
                                                                </span>
                                                            </li>

                                                            <li className="submenu-list list-border">
                                                                <span className="submenu-option ">
                                                                    <img
                                                                        src={
                                                                            product
                                                                        }
                                                                        alt="imag"
                                                                        className="img-fluid submenu-option-icon"
                                                                    />
                                                                    Product
                                                                    Updates
                                                                </span>
                                                            </li>

                                                            <li className="submenu-list">
                                                                <span className="submenu-option-left">
                                                                    <img
                                                                        src={
                                                                            contact
                                                                        }
                                                                        alt="img"
                                                                        className="img-fluid submenu-option-icon"
                                                                    />
                                                                    Contact Us
                                                                </span>
                                                            </li>

                                                            <li className="copyright-submenu">
                                                                <span className="copyright-option">
                                                                    Copyright ©
                                                                    2022 Limn
                                                                    Labs Inc.,
                                                                    All rights
                                                                    reserved
                                                                </span>
                                                            </li>
                                                        </ul>
                                                    ) : null}
                                                </div>
                                            </li>
                                            <li className="right-header list">
                                                <div className="horizontal-menu">
                                                    <div
                                                        className="e-avatar e-avatar-medium e-avatar-circle mb-1"
                                                        onClick={() =>
                                                            handleProfileMenu()
                                                        }
                                                    >
                                                        {loggedinUserInfo?.image !==
                                                            undefined &&
                                                        loggedinUserInfo?.image !==
                                                            null &&
                                                        loggedinUserInfo?.image !==
                                                            '' ? (
                                                            <img
                                                                alt="avatar"
                                                                src={`data:image/png;base64,${loggedinUserInfo.image}`}
                                                                className="profile-avatar"
                                                                height="100"
                                                                width="100"
                                                            />
                                                        ) : loggedinUserInfo?.firstname !==
                                                          undefined ? (
                                                            <div className="header-profile-logo">
                                                                <p className="mt-1">
                                                                    {loggedinUserInfo?.firstname
                                                                        ?.substring(
                                                                            0,
                                                                            1
                                                                        )
                                                                        ?.toUpperCase() +
                                                                        loggedinUserInfo?.lastname
                                                                            ?.substring(
                                                                                0,
                                                                                1
                                                                            )
                                                                            ?.toUpperCase()}
                                                                </p>
                                                            </div>
                                                        ) : (
                                                            <div className="header-profile-logo">
                                                                <p className="mt-1">
                                                                    {username
                                                                        ?.match(
                                                                            /\b(\w)/g
                                                                        )
                                                                        ?.join(
                                                                            ''
                                                                        )
                                                                        ?.substring(
                                                                            0,
                                                                            2
                                                                        )
                                                                        ?.toUpperCase()
                                                                        .length >
                                                                    1
                                                                        ? username
                                                                              ?.match(
                                                                                  /\b(\w)/g
                                                                              )
                                                                              ?.join(
                                                                                  ''
                                                                              )
                                                                              ?.substring(
                                                                                  0,
                                                                                  2
                                                                              )
                                                                              ?.toUpperCase()
                                                                        : username
                                                                              ?.substring(
                                                                                  0,
                                                                                  2
                                                                              )
                                                                              ?.toUpperCase()}
                                                                </p>
                                                            </div>
                                                        )}
                                                    </div>
                                                    {showMenu ? (
                                                        <ul
                                                            className="submenu-show"
                                                            style={{
                                                                background:
                                                                    'white !important',
                                                            }}
                                                        >
                                                            <li className="submenu-list">
                                                                <span className="submenu-option ">
                                                                    {loggedinUserInfo?.image !==
                                                                        undefined &&
                                                                    loggedinUserInfo?.image !==
                                                                        null &&
                                                                    loggedinUserInfo?.image !==
                                                                        '' ? (
                                                                        <div className="e-avatar e-avatar-medium e-avatar-circle">
                                                                            <img
                                                                                alt="avatar"
                                                                                src={`data:image/png;base64,${loggedinUserInfo.image}`}
                                                                                className="profile-avatar header-user-logo"
                                                                                height="100"
                                                                                width="100"
                                                                            />
                                                                        </div>
                                                                    ) : loggedinUserInfo?.firstname !==
                                                                      undefined ? (
                                                                        <p className="header-user-logo">
                                                                            {loggedinUserInfo?.firstname
                                                                                ?.substring(
                                                                                    0,
                                                                                    1
                                                                                )
                                                                                ?.toUpperCase() +
                                                                                loggedinUserInfo?.lastname
                                                                                    ?.substring(
                                                                                        0,
                                                                                        1
                                                                                    )
                                                                                    ?.toUpperCase()}
                                                                        </p>
                                                                    ) : (
                                                                        <p className="header-user-logo">
                                                                            {username
                                                                                ?.substring(
                                                                                    0,
                                                                                    2
                                                                                )
                                                                                ?.toUpperCase()}
                                                                        </p>
                                                                    )}

                                                                    {loggedinUserInfo &&
                                                                    loggedinUserInfo?.firstname !==
                                                                        undefined ? (
                                                                        <p className="user-info">
                                                                            {' '}
                                                                            {loggedinUserInfo?.firstname?.toUpperCase() +
                                                                                ' ' +
                                                                                loggedinUserInfo?.lastname?.toUpperCase()}
                                                                        </p>
                                                                    ) : (
                                                                        <p className="user-info">
                                                                            {username?.toUpperCase()}
                                                                        </p>
                                                                    )}
                                                                    <img
                                                                        src={
                                                                            settings
                                                                        }
                                                                        className="img-fluid"
                                                                    />
                                                                </span>
                                                            </li>

                                                            <li
                                                                className="submenu-list"
                                                                onClick={() => {
                                                                    handleLogout();
                                                                }}
                                                            >
                                                                <span className="submenu-option">
                                                                    <img
                                                                        src={
                                                                            logout
                                                                        }
                                                                        className="img-fluid submenu-option-icon"
                                                                    />
                                                                    Sign out
                                                                </span>
                                                            </li>
                                                        </ul>
                                                    ) : null}
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    {structedMenuItems &&
                                    structedMenuItems.length > 0 &&
                                    structedMenuItems !== undefined ? (
                                        <div className="col-lg-12 col-sm-12 col-md-12 brdCmb-secondary">
                                            <Breadcrumb />
                                        </div>
                                    ) : (
                                        <></>
                                    )}
                                    <div
                                        className="col-lg-12 col-sm-12 col-md-12 p-0 main-content body-route"
                                        id="maintext"
                                    >
                                        {structedMenuItems ? (
                                            <>
                                                {structedMenuItems?.length >
                                                    0 &&
                                                structedMenuItems !==
                                                    undefined ? (
                                                    <div className="sidebar-menu-content">
                                                        {children}
                                                    </div>
                                                ) : (
                                                    <div className="col-sm-12 d-flex align-items-center errormsgDiv">
                                                        {' '}
                                                        <div className="col-sm-12 d-flex justify-content-center">
                                                            {' '}
                                                            <p className="font-24  text-danger">
                                                                You DO NOT have
                                                                designated role
                                                                assigned to
                                                                access this
                                                                page.{' '}
                                                            </p>
                                                        </div>
                                                    </div>
                                                )}
                                            </>
                                        ) : (
                                            <></>
                                        )}
                                    </div>
                                </div>
                                {/* </div> */}
                            </div>
                        </div>
                    </>
                </div>
            ) : (
                <></>
            )}
        </div>
    );
};
export default SidebarWithMenu;
